import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

/** Returns the current tenant's ID, or undefined for users who are not logged in */
export default function useTenantId() {
  const params = useParams()
  const tenantId = useMemo(() => params?.tenantId as string | undefined, [params?.tenantId])
  return tenantId
}
